import { getMotiveReopenClaim } from "../api/motiveReopenClaim";
import GenericDictionaryPage from "./GenericDictionaryPage";


export default function ClaimReopenReason() {

    return (
           <GenericDictionaryPage
               tableKey="claimReopenReason"
               fetchData={getMotiveReopenClaim}
               titleKey="genericDic:claimReopenReason"
               newButtonLabel={({ t }) =>
                   t("genericDic:claimReopenReasonButtonNew", {
                       tableName: t("genericDic:claimReopenReason").toLowerCase()
                   })
               }
           /> 
       );
   }
    


